import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { formatTurkishToEnglishString } from "../../../helpers/TodayDate";
import { ThemeContext, ThemeProviderComponent } from "../../../context/themeProviderContext";

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const { menuListAll } = useContext(ConstantAPISContext);
  const { primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, buttonVariant, setButtonVariant }:any = useContext(ThemeContext);

  return (
    <MUIBreadcrumbs
      aria-label="breadcrumb"
      separator="›"
      style={{ minWidth: "fit-content",color:primaryColor}}
      className="d-flex align-items-center justify-content-star px-1 my-2 mb-2"
    >
      <Link
                color={primaryColor}

        underline="hover"
        sx={{ fontWeight: "bolder",color:primaryColor }}
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      >
        Anasayfa
      </Link>
      {pathnames.map((name, index) => {
        const routeTo = `anasayfa/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        // Normalize the current path segment
        let guncelAd = menuListAll.find((item) => {
          const normalizedMenuName = formatTurkishToEnglishString(item.menuAdi.replaceAll(" ", "-"));
          return normalizedMenuName === name;
        });
        

        // If no corresponding menu item is found, attempt to find by page link
        if (!guncelAd) {
          // Remove 'anasayfa' from the start of the pathname if it exists
          let normalizedPath = location.pathname.replace(/^\/anasayfa/, "");

          guncelAd = menuListAll.find((item) => {
            const normalizedMenuName = item.sayfaLink;
            return normalizedMenuName === normalizedPath;
          });
        }

        // If no corresponding menu item is found, skip this segment
        if (!guncelAd) {
          return null; // Skip breadcrumb if no matching item found
        }

        return name === "anasayfa" || name === "anketler" ? null : isLast ? (
          <Typography           color={primaryColor}
          key={name}>
            {guncelAd.menuAdi}
          </Typography>
        ) : (
          <Link
          color={primaryColor}
            underline="hover"
            onClick={() => navigate(routeTo)}
            key={name}
            sx={{ fontWeight: "bold" ,color:primaryColor}}
            style={{ cursor: "pointer" }}
          >
            {guncelAd.menuAdi}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
